import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { DubniumDialog } from '@adornis/digitale-helden-shared/client/theme/d-dialog.js';
import type { SupportedFileType } from '@adornis/digitale-helden-shared/features/mediaverwaltung/client/las-file-explorer.js';
import { stateful } from '@adornis/functional-lit/stateful';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './las-file-explorer';

@customElement('las-prompt-choose-file')
export class LASPromptChooseFile extends DubniumDialog<Maybe<string>> {
  @property({ type: String }) selectedFileID: Maybe<string>;
  @property({ attribute: false }) allowedFileTypes = new RXController<Array<SupportedFileType>>(this, []);

  private _onFileChanged = (e: ValueEvent<Maybe<string>>) => {
    this.selectedFileID = e.detail.value;
  };

  override content() {
    return html`
      <d-flex
        space="lg"
        ${css({
          height: '80vh',
          width: '80vh',
        })}
      >
        <d-flex
          horizontal
          crossaxis-center
          space-between
          ${css({
            padding: this.spacing.md,
            position: 'sticky',
            top: '0',
            background: '#fff',
            zIndex: '99999',
            borderBottom: `1px solid ${this.colors.tone.border}`,
          })}
        >
          <d-button mode="outline" @click=${() => this.cancel()}> Abbrechen </d-button>
          <d-button ?disabled=${!this.selectedFileID} @click=${() => this.close(this.selectedFileID)}>
            Speichern
          </d-button>
        </d-flex>
        <las-file-explorer
          selectable
          @file-changed=${this._onFileChanged}
          .allowedFileTypes=${this.allowedFileTypes.value}
        ></las-file-explorer>
      </d-flex>
    `;
  }

  override async cancel() {
    return super.close(this.selectedFileID);
  }

  static override get element_name() {
    return 'las-prompt-choose-file';
  }
}

const FileExplorer = stateful(
  ({
    allowedFileTypes,
    onFileChanged,
  }: {
    allowedFileTypes: Array<SupportedFileType>;
    onFileChanged: (e: ValueEvent<Maybe<string>>) => void;
  }) => {
    return html`
      <las-file-explorer
        selectable
        @file-changed=${onFileChanged}
        .allowedFileTypes=${allowedFileTypes}
      ></las-file-explorer>
    `;
  },
);
